const convertOptionsToPropertyOptions = options => {
  return options.filter(option => option.value).map(option => {
    const {
      displayOrder,
      hidden,
      label,
      readOnly,
      value
    } = option;
    return Object.assign({}, option, {
      displayOrder: displayOrder || 0,
      hidden: hidden || false,
      label: label || '',
      readOnly: readOnly || false,
      value: value
    });
  });
};
const fieldTypeDefinitionToPropertyAdapter = fieldTypeDefinition => {
  const {
    description,
    externalOptions,
    externalOptionsReferenceType,
    fieldType,
    label,
    name,
    options,
    referencedObjectType,
    type
  } = fieldTypeDefinition;
  if (fieldType === 'calculation_read_time' || fieldType === 'unknown' || !fieldType || type === 'json' || type === 'object_coordinates' || type === 'currency_number') {
    return undefined;
  }
  return {
    calculated: false,
    deleted: false,
    description: description || '',
    displayOrder: 0,
    externalOptions,
    externalOptionsReferenceType,
    fieldType,
    formField: false,
    groupName: '',
    hasUniqueValue: false,
    hidden: false,
    isCustomizedDefault: false,
    label: label || '',
    mutableDefinitionNotDeletable: false,
    name,
    options: convertOptionsToPropertyOptions(options || []),
    readOnlyDefinition: false,
    readOnlyValue: false,
    referencedObjectType,
    searchableInGlobalSearch: false,
    type: type
  };
};
export default fieldTypeDefinitionToPropertyAdapter;